import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BlogCard from './BlogCard';
import Icon from '../../../components/AppIcon';


const BlogGrid = ({ posts, loading }) => {
  const location = useLocation();

  useEffect(() => {
    if (!loading && posts.length > 0) {
      const savedScroll = sessionStorage.getItem(`scroll-${location.pathname}`);
      if (savedScroll) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScroll, 10));
          sessionStorage.removeItem(`scroll-${location.pathname}`);
        }, 50);
      }
    }
  }, [loading, posts.length, location.pathname]);

  if (loading) {
    return (
      <section className="bg-background pt-8 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl overflow-hidden animate-pulse">
                <div className="h-48 bg-white/10"></div>
                <div className="p-6">
                  <div className="h-4 bg-white/10 rounded mb-4 w-3/4"></div>
                  <div className="space-y-2 mb-6">
                    <div className="h-3 bg-white/10 rounded w-full"></div>
                    <div className="h-3 bg-white/10 rounded w-full"></div>
                    <div className="h-3 bg-white/10 rounded w-2/3"></div>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                      <div className="w-8 h-8 rounded-full bg-white/10"></div>
                      <div className="h-3 bg-white/10 rounded w-20"></div>
                    </div>
                    <div className="h-3 bg-white/10 rounded w-16"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (posts.length === 0) {
    return (
      <section className="bg-background pt-8 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center py-12">
            <div className="bg-surface-100 p-6 rounded-full w-24 h-24 mx-auto mb-6 flex items-center justify-center">
              <Icon name="Search" size={32} className="text-text-muted" />
            </div>
            <h3 className="font-heading text-xl font-semibold text-text-primary mb-2">
              No Posts Found
            </h3>
            <p className="font-body text-text-secondary">
              Try adjusting your search terms or browse different categories.
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-background pt-8 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogGrid;